// Curated, not procedural — lets one color be tuned without perturbing the
// rest. Beyond the list, colors repeat rather than generating new shades.
const PALETTE = [
	"#8a1010", // maroon / dark red
	"#1e5631", // pine green
	"#1e3a8a", // dark blue
	"#c2540a", // orange
	"#0f766e", // teal
	"#9d174d", // rose
	"#6b5b1f", // olive
	"#4c3575", // violet
]

export const getRouteColor = (index: number): string =>
	PALETTE[index % PALETTE.length]
